import { useNavigate } from "react-router-dom";
import { CHANNELS_CONFIG } from "./channels.config";
import { isFeatureAllowed } from "../../../shared/utils/featureAccess";

export function useChannelOptions(featureAccess) {
  const navigate = useNavigate();

  return CHANNELS_CONFIG.map((channel) => ({
    ...channel,
    status: "active",
    alreadyPaid: isFeatureAllowed(featureAccess, channel.key, true),
    handleClick: () => navigate(channel.route),
  }));
}
